export default [
    {
        name: 'cadastro-modulo',
        path: 'modulo',
        redirect: 'modulo/index',
        component: () => import(/* webpackChunkName: 'cadastro-modulo' */ '@/views/cadastro/modulo/Index'),
        children: [
            {
                meta: {title: 'Lista de módulos'},
                name: 'cadastro-modulo-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-modulo' */ '@/views/cadastro/modulo/List.vue'),
            },
        ],
    },
]